module.exports = __webpack_public_path__ + "static/media/default-avatar-icon.51862156.svg";